import MgecApi from 'mgec-jssdk'
import axios from 'axios'
import { fetchGoodsDetail } from '@/service/action'
import { isInMgApp } from '@ecom/utils'

export function isIphone(): boolean {
  return /iphone/.test(navigator.userAgent.toLowerCase())
}

export function isAphone(): boolean {
  return /android/.test(navigator.userAgent.toLowerCase())
}

export function isIpad(): boolean {
  return /ipad/.test(navigator.userAgent.toLowerCase())
}
export function isWeixin() {
  return /micromessenger/.test(navigator.userAgent.toLowerCase())
}
export function isQQClient() {
  return /qq\/[0-9]/.test(navigator.userAgent.toLowerCase())
}
export function $(el: string) {
  return document.querySelector(el)
}

export function isNotBrowser() {
  const ua = navigator.userAgent.toLowerCase()
  return (
    /qq\/|qq \//.test(ua) ||
    /weibo/.test(ua) ||
    /micromessenger/.test(ua) ||
    /imgo/.test(ua)
  )
}
export function preventDoubClick() {
  let agent = navigator.userAgent.toLowerCase()
  let iLastTouch = 0
  if (agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0) {
    document.body.addEventListener(
      'touchend',
      function(event) {
        let a = new Date().getTime()
        iLastTouch = iLastTouch || a + 1
        let c = a - iLastTouch
        if (c < 500 && c > 0) {
          event.preventDefault()
          return false
        }
        iLastTouch = a
      },
      false
    )
  }
}
export function addEventTransition(el: string, className: string) {
  const dom = $(el) as HTMLDivElement
  const handlerFn = () => {
    dom.classList.remove(className)
    dom.removeEventListener('webkitTransitionEnd', handlerFn, false)
  }
  dom.addEventListener('webkitTransitionEnd', handlerFn, false)
}

/**
 * 是否在APP内
 */
export function isInApp(): boolean {
  return /imgoec/.test(navigator.userAgent.toLowerCase())
}

export function isInMgTvApp() {
  return /imgotv/.test(navigator.userAgent.toLowerCase())
}

export function parseQuery(link?: any) {
  const url = link ? link : location.href
  const theRequest: any = {}

  if (url.indexOf('?') != -1) {
    const str = url.substr(url.indexOf('?') + 1)
    const strs = str.split('&')

    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }

  return theRequest
}

/**
 * 是否在APP内
 */
export function removeSkeleton() {
  try {
    const skeleton = document.querySelector(
      '.app-skeleton-load'
    ) as HTMLDivElement
    const body = document.querySelector('body') as HTMLBodyElement //document.body 低版本获取不到
    if (skeleton) body.removeChild(skeleton)
  } catch (e) {}
}

/**
 * 请求成功
 * @param res
 * @param callback
 */
export function fetchSuccess(
  res: any,
  callback: Function,
  errback?: Function | undefined
) {
  if (res.status === 200 && res.data.code === 200) {
    typeof callback === 'function' && callback(res.data.data)
    removeSkeleton()
  } else {
    errback && errback(res.data)
  }
}

//获取导航栏告诉
export function getWebviewHeight() {
  return new Promise(resolve => {
    if (!isInApp()) {
      const obj = {
        navHeight: 60 * (window.screen.width / 375),
        stateHeight: 0,
      }
      resolve(obj)
      return
    }
    MgecApi.callhandler(
      'setWebview',
      {
        navigationBarTextStyle: 'black', // 导航栏标题颜色，仅支持 black / white
        bouncing: false, // 是否开启webview的回弹效果 true：启用，false：禁用
        popGesture: true, // 无侧滑返回功能
      },
      (data: any) => {
        let ret
        if (typeof data === 'string') {
          ret = JSON.parse(data)
        } else if (typeof data === 'object') {
          ret = data
        }
        if (ret.code == 200) {
          ret.data.navHeight = ret.data.navHeight * (window.screen.width / 375)
          resolve(ret.data)
        }
      }
    )
  })
}
//动态引入js
export function loadJs(src: any) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.onload = () => {
      resolve()
    }
    script.onerror = () => {
      reject()
    }
    script.src = src
    document.getElementsByTagName('body')[0].appendChild(script)
  })
}

export function isIOS() {
  return /ipad|iphone|ipod/.test(navigator.userAgent.toLowerCase())
}

export function iswebKit() {
  return /applewebkit/.test(navigator.userAgent.toLowerCase())
}

export function isWeibo() {
  return /WeiBo/i.test(navigator.userAgent.toLowerCase())
}

// v1>v2则返回 1， v1==v2返回0，v1<v2返回-1
export function compareVersion(v1: string, v2: string) {
  let varr1 = v1.split('.')
  let varr2 = v2.split('.')
  const len = Math.max(varr1.length, varr2.length)

  while (varr1.length < len) {
    varr1.push('0')
  }
  while (varr2.length < len) {
    varr2.push('0')
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(varr1[i])
    const num2 = parseInt(varr2[i])

    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }

  return 0
}
export function openApp(
  downurl: string = '',
  link = '',
  isugcLick = false,
  topicId: any = -1
) {
  const ua = navigator.userAgent.toLowerCase()
  const isWX = /micromessenger/.test(ua)
  const isQQ = /qq\/|qq \//.test(ua)
  let curUrl = link || window.location.href

  curUrl = curUrl.replace('xm.mgtv', 'ecom.mgtv')
  curUrl = curUrl.replace('isHideNavBar=0', 'isHideNavBar=1')
  const commSchemeUrl = `imgoecom://webview?url=${encodeURIComponent(curUrl)}${
    isugcLick
      ? `&native=${encodeURIComponent(
          'imgoecom://ugctopic?topicId=' + topicId
        )}`
      : ''
  }`

  if (isWX || isQQ) {
    window.location.href =
      'https://a.app.qq.com/o/simple.jsp?pkgname=com.mg.ec&ios_scheme=' +
      encodeURIComponent(commSchemeUrl) +
      '&android_schema=' +
      encodeURIComponent(commSchemeUrl)
    return
  }

  const isIos = isIOS() || iswebKit()

  if (isIos) {
    const aLink = document.createElement('a')
    const body = document.body
    aLink.style.cssText = 'display:none;width=0;height=0'
    aLink.href = commSchemeUrl
    body.appendChild(aLink)
    aLink.click()
  } else {
    const iframe = document.createElement('iframe')
    const body = document.body
    iframe.style.cssText = 'display:none;width=0;height=0'
    body.appendChild(iframe)
    iframe.src = commSchemeUrl
  }

  const timer = setTimeout(() => {
    location.href = downurl
  }, 3000)
  window.addEventListener('pagehide', function() {
    clearTimeout(timer)
  })
  document.addEventListener('visibilitychange', function() {
    clearTimeout(timer)
  })
  //需要分开些visibilitychange  webkitvisibilitychange
  const clearfun = () => {
    if (document.hidden) {
      clearTimeout(timer)
    }
  }
  ;['visibilitychange', 'webkitvisibilitychange'].forEach(function(
    item,
    index
  ) {
    window.addEventListener(item, clearfun)
  })

  // window.location.href =
  //   'https://ecom.hitv.com/download.html?webviewUrl=' +
  //   encodeURIComponent(curUrl)
}
export function getDownUrl() {
  return new Promise((resolve, reject) => {
    axios.get('//mgesq.api.mgtv.com/config/download').then(res => {
      const {
        data: { code, data },
      } = res
      if (code != 200) {
        reject({})
        return
      }
      const { android, ios } = data

      let downUrl = ''
      if (isIphone()) {
        downUrl = ios
      } else {
        downUrl = android
      }
      resolve(downUrl)
    })
  })
}

export function getPosition() {
  return new Promise((resolve, reject) => {
    MgecApi.callhandler(
      'getGeoPosition',
      {},
      (data: any) => {
        console.log(data)
        let ret
        if (typeof data === 'string') {
          ret = JSON.parse(data)
        } else if (typeof data === 'object') {
          ret = data
        }
        if (ret.code == 200) {
          console.log(ret.data)
          resolve(ret.data)
        } else {
          reject('你的浏览器不支持当前地理位置信息获取')
        }
      }
      // resp ={code:200,data:{
      //"latitude":0, //纬度
      //"longitude":0,//经度
      //"province":"福建省","city":"福州市","district":"台江区"}}
    )
  })
}

/**
 * 判断数据为空
 * @param {any} value
 */
export const isNull = (value: any) => {
  if (typeof value === 'undefined' || value === null) {
    return true
  }
  if (typeof value === 'object' || typeof value === 'function') {
    return false
  }
  // const isEmptyString = typeof value === 'string' && value === ''
  const isNotANumber =
    typeof value === 'number' &&
    (Number.isNaN(value) || !Number.isFinite(value))
  return isNotANumber
}

export function removeEmojis(str: string) {
  var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g
  return str.replace(regex, '')
}
export const isNotNull = (value: any) => !isNull(value)

export function detailRichVideo(content: string) {
  let reg = /&lt;videoitem.+?videoitem&gt;/
  let result = null
  let richDecodeList = []
  let idx = 0
  result = reg.exec(content)
  do {
    if (result) {
      let domstr =
        '<div class="video-item"><div id="player-' + idx + '"></div></div>'
      let tmp: any = {}
      let vidStr = /&gt;.+?&lt/.exec(result[0])
      if (vidStr) {
        tmp.vid = vidStr[0].substring(4, vidStr[0].length - 3)
      }
      let poster = /data-poster=".+"&gt;/.exec(result[0])
      if (poster) {
        tmp.poster = poster[0].substring(13, poster[0].length - 5)
      }
      richDecodeList.push(tmp)
      content = content.replace(result[0], domstr)
      result = reg.exec(content)
      idx++
      if (idx >= 20) result = null
    }
  } while (result)

  return {
    content: content,
    richDecodeList: richDecodeList,
  }
}

export async function detailRichGoods(content: any) {
  content = escape2Html(content)
  const reg = /<gooditem>(\d+)<\/gooditem>/g
  const goodsList = content.match(reg)?.map((v: any) => {
    return v.match(/<gooditem>(\d+)<\/gooditem>/)[1]
  })
  if (!goodsList || goodsList.length == 0) {
    return content
  }
  const {
    data: { code, data },
  } = (await fetchGoodsDetail(goodsList.join(','))) as any
  let result = ''
  if (code === 200) {
    result = content.replace(reg, (str: string, goodId: string) => {
      const info = data.find((v: any) => v.GoodsId == goodId)
      return `
      <div class="rich__good good__item" data-goodsid="${goodId}" data-jumpUrl="${
        info.jumpUrl
      }">
        <div
          class="good__item--left"
          style="background-image: url(${info.img})"
        ></div>
        <div class="good__item--middle">
          <div class="good__item--name">${info.title}</div>
          ${
            info.goodsTags && info.goodsTags[0]
              ? `<div class="good__item--tag-wrap">
            <div class="good__item--tag">
              <span class='good__item--tag-first'>${info.goodsTags[0].first_title}</span>
              <span class='good__item--tag-second'>${info.goodsTags[0].second_title}</span>
            </div>
          </div>`
              : ''
          }
          <div class="good__item--price">
            <span class='rmb'>¥</span>
            <span class='yuan'>${
              (info.shop_price / 100).toFixed(2).split('.')[0]
            }.</span>
            <span class='jiao'>${
              (info.shop_price / 100).toFixed(2).split('.')[1]
            }</span>
          </div>
        </div>
        <div class="good__item--right"></div>
      </div>`
    })
  } else {
    result = content.replace(reg, (str: string, goodId: string) => {
      return ''
    })
  }
  return result
}

function escape2Html(str: string) {
  const arrEntities: any = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '"' }
  return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, (all, t) => arrEntities[t])
}

export function getRankTabParam(active: number) {
  let name = ''
  switch (active) {
    case 1:
      name = 'daily'
      break
    case 2:
      name = 'weekly'
      break
    case 3:
      name = 'monthly'
      break
    case 4:
      name = 'year'
      break
    default:
      name = ''
  }
  return name
}

export const handlerJump = (link: string) => {
  if (!link) return
  const isScheme = /imgoecom/.test(link) || false

  if (isScheme) {
    if (!isInApp()) {
      link = `https://xm.mgtv.com/app-launch.html?schemaUrl=${encodeURIComponent(link)}&xmapplinkJump=${link}`
    }
    location.href = link
  } else {
    if (isInApp()) {
      MgecApi.callhandler('jumpPage', {
        destinationUrl: link,
      })
    } else if (isInMgApp()) {
      const win = window as any
      win.MgtvApi.jumpPage({
        url: link,
      })
    } else {
      location.href = link
    }
  }
}

export const funcUrlDel = (url: string, keys: any) => {
  if (typeof keys == 'string') {
    keys = [keys]
  }
  const urlList = url.split('?') // 有多个query的情况
  const obj: any = {}
  const arr: any = urlList[1].split('&')
  //获取参数转换为object
  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].split('=')
    obj[arr[i][0]] = arr[i][1]
  }
  //删除指定参数
  for (let i = 0; i < keys.length; i++) {
    delete obj[keys[i]]
  }
  //重新拼接url
  const sub = Object.keys(obj)?.length === 0 ? '' : '?'
  const result =
    urlList[0] +
    sub +
    JSON.stringify(obj)
      .replace(/[\"\{\}]/g, '')
      .replace(/\:/g, '=')
      .replace(/\,/g, '&')
  return result
}

/**
 * @description: 保存图片到本地
 * @param {any} imgUrl 图片地址
 * @param {string} name
 * @return {Promise}
 */
export const saveImg = (imgUrl: any, name: string) => {
  return new Promise(resolve => {
    const a = document.createElement('a')
    a.style.display = 'none'
    a.download = `${name}_${Date.now()}`
    let blob: any
    if (/^https?|ftp|data:/.test(imgUrl)) {
      if (/^https/.test(imgUrl))
        imgUrl = imgUrl.replace(/\?x\-oss\-process[\s\S]*/g, '')
      a.href = imgUrl
    } else {
      blob =
        imgUrl instanceof Blob
          ? imgUrl
          : new Blob(imgUrl instanceof Array ? imgUrl : [imgUrl], {
              type: 'text/plain;charset=utf-8',
            })
      a.href = URL.createObjectURL(blob)
    }
    setTimeout(() => {
      a.click()
      setTimeout(() => {
        a.remove()
        resolve({})
        if (blob instanceof Blob) {
          setTimeout(() => {
            URL.revokeObjectURL(blob)
          }, 1000)
        }
      }, 1)
    }, 0)
  })
}

export const dealUserData = (
  comment: any,
  className: string = 'at-user',
  replyInd?: number
) => {
  let str = comment.content
  if (comment.at_user_infos && comment.at_user_infos.length > 0) {
    let strCurrent = ''
    comment.at_user_infos.forEach((item: any, index: number) => {
      strCurrent += str.substring(
        index == 0
          ? -1
          : comment.at_user_infos[index - 1].s +
              comment.at_user_infos[index - 1].l,
        item.s
      )
      strCurrent += `<i class="${className}" style="font-style: normal;color: #3c86dd;" index="${index}"${
        replyInd != void 0 ? ' reply-ind="' + replyInd + '"' : ''
      }>${str.substring(item.s, item.s + item.l)} </i>`
      if (index == comment.at_user_infos.length - 1)
        strCurrent += str.substring(item.s + item.l)
    })

    str = strCurrent
  }
  return str
}

export function hexToRgba(hex: string, opacity = 1) {
  if (!hex || hex.indexOf('#') === -1) return hex
  return (
    'rgba(' +
    parseInt('0x' + hex.slice(1, 3)) +
    ',' +
    parseInt('0x' + hex.slice(3, 5)) +
    ',' +
    parseInt('0x' + hex.slice(5, 7)) +
    ',' +
    opacity +
    ')'
  )
}
